<template>
  <div >
      <vs-textarea  rows="3" style="width:100%" v-model="params.data.transactionDetail" />

  </div>
  
</template>

<script>
export default {
  name: "CellRendererDetailList",
  data() {
    return {
      detailList: [],
      span: "",
    };
  },
  computed: {},
  beforeMount() {},
};
</script>
